import { Flex } from "@strapi/design-system";
import { Button } from "antd";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  LeftOutlined,
  RightOutlined,
  SaveOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";

const ButtonGroup = ({
  isShow = true,
  isFirst = false,
  isLast = false,
  onSave = () => {},
  onPrev = () => {},
  onNext = () => {},
  onSubmit = () => {},
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`${!isShow ? styles.displayNone : ""}`}>
      <div className="show-xs">
        <Flex size={4} justifyContent="end">
          <Button
            onClick={onSave}
            className={`${styles.btnSave}`}
            disabled={disabled}
          >
            <SaveOutlined />
          </Button>
          <Button
            onClick={onPrev}
            className={`${styles.btnPrev} ${isFirst ? styles.displayNone : ""}`}
            disabled={disabled}
          >
            <LeftOutlined />
          </Button>
          <Button
            onClick={onNext}
            className={`${styles.btnNext} ${isLast ? styles.displayNone : ""}`}
            disabled={disabled}
          >
            <RightOutlined />
          </Button>
          <Button
            onClick={onSubmit}
            className={`${styles.btnSubmit}`}
            disabled={disabled}
          >
            <FileDoneOutlined />
          </Button>
        </Flex>
      </div>
      <div className="show-md">
        <Flex size={4} justifyContent="end">
          <Button
            onClick={onSave}
            className={`${styles.btnSave}`}
            disabled={disabled}
          >
            <span>{t("str_save")}</span>
          </Button>
          <Button
            onClick={onPrev}
            className={`${styles.btnPrev} ${isFirst ? styles.displayNone : ""}`}
            disabled={disabled}
          >
            <span>{t("str_prev")}</span>
          </Button>
          <Button
            onClick={onNext}
            className={`${styles.btnNext} ${isLast ? styles.displayNone : ""}`}
            disabled={disabled}
          >
            <span>{t("str_next")}</span>
          </Button>
          <Button
            onClick={onSubmit}
            className={`${styles.btnSubmit}`}
            disabled={disabled}
          >
            <span>{t("str_submit")}</span>
          </Button>
        </Flex>
      </div>
    </div>
  );
};

export default ButtonGroup;
